// admin-dashboard-opdracht.md §5: "dezelfde vier als het e-maildashboard, in deze vaste
// volgorde." Never assign round-robin - each named series always gets its own fixed color, a
// 5th series becomes "Overig" instead of wrapping back to cat1. Matches
// pages/email/report/components/EmailReportVolumeChart.tsx's own CATEGORY_COLOR.
export const DASHBOARD_COLOR = {
  cat1: '#2c9424',
  cat2: '#2a78d6',
  cat3: '#eb6834',
  cat4: '#4a3aa7',
  ok: '#2c9424',
  warn: '#f0ca00',
  err: '#f87171',
  grid: '#e5e7eb',
  muted: '#9ca3af',
  running: '#c9ced6',
} as const;
